/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * ベータフラグ更新APIのレスポンスボディ
 * @export
 * @interface UpdatePressReleaseEditorBetaFlgResponse
 */
export interface UpdatePressReleaseEditorBetaFlgResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof UpdatePressReleaseEditorBetaFlgResponse
     */
    status?: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof UpdatePressReleaseEditorBetaFlgResponse
     */
    message?: string;
}

export function UpdatePressReleaseEditorBetaFlgResponseFromJSON(json: any): UpdatePressReleaseEditorBetaFlgResponse {
    return UpdatePressReleaseEditorBetaFlgResponseFromJSONTyped(json, false);
}

export function UpdatePressReleaseEditorBetaFlgResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePressReleaseEditorBetaFlgResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function UpdatePressReleaseEditorBetaFlgResponseToJSON(value?: UpdatePressReleaseEditorBetaFlgResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

